//
//
//
//
//
//
//
//
//

export default {
    props : {
        from_manager_page : {
            type : Number,
            default : -1
        },
        cancel : {
            type : Boolean,
            default : false,
        },
        subscription_confirmed : {
            type : Boolean,
            default : false
        }
    },
    data : function () {
        return {
            translations: rest_options.options.translations,
        }
    },
}



// WEBPACK FOOTER //
// ./js/vue/notification-manager/notification-confirmation.vue